import React from "react";
import BaseComponent from "../../baseComponent.js";
import WidgetType from "../../../core/constants/widgetType.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import DashboardService from "../../../core/services/dashboardService.js";
import styles from "./widget-action.scss";

export default class WidgetActions extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      dashboardLocked: DashboardService.getActiveDashboardLockState(),
      showResumeButton: false
    };

    this.subscribe(InternalEvent.Dashboard.DASHBOARD_LOCK_TOGGLED, () => {
      this.setState({
        dashboardLocked: DashboardService.getActiveDashboardLockState()
      });
    });

    this.subscribe(InternalEvent.Widget.HISTORY_MODE_TOGGLED, payload => {
      if (payload.widgetId === this.props.widgetId && payload.value) {
        this.setState({
          showResumeButton: true
        });
      }
    });
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  requirePlayButton() {
    return this.props.widgetType === WidgetType.TIME_SERIES ||
      this.props.widgetType === WidgetType.TIME_SERIES_VERTICAL ||
      this.props.widgetType === WidgetType.TABLE;
  }

  show() {
    $(this.refs.container).stop().fadeIn();
  }

  hide() {
    $(this.refs.container).stop().fadeOut();
  }

  render() {
    let actions = [];
    if (!this.state.dashboardLocked) {
      actions.push(<i className="icon-cursor-move grid-move-btn" key="move"/>);
      actions.push(<span style={{flex: 1}} key="space"/>);
    } else {
      actions.push(<span style={{flex: 1}} key="space"/>);
    }

    if (this.requirePlayButton() && this.state.showResumeButton) {
      actions.push(<i className="icon-control-play"
                      ref="resumeRealtimeBtn" onClick={this.props.onRealtimeResumeButtonClick}
                      key="resumeRealtimeBtn"/>);
    }

    if ([WidgetType.CONTROL_WIDGET, WidgetType.SEPARATOR_VERTICAL].indexOf(this.props.widgetType) === -1) {
      if (!this.state.dashboardLocked) {
        actions.push(<i className="icon-docs" onClick={this.props.onCopyButtonClick} key="copy"/>);
      }
      actions.push(<i className={ this.props.isMaximized ? "icon-size-actual" : "icon-size-fullscreen"}
                      onClick={this.props.toggleMaximize}
                      style={{fontSize: "15px"}} key="toggleMax"/>);
    }

    if (!this.state.dashboardLocked) {
      if ([WidgetType.SEPARATOR_VERTICAL].indexOf(this.props.widgetType) === -1) {
        actions.push(<i className="icon-note" onClick={this.props.onEditButtonClick}
                        style={{marginLeft: "7px"}} key="edit"/>);
      }
      actions.push(<i className="icon-close" onClick={this.props.onRemoveButtonClick} key="remove"/>);
    }

    return (
      <div className={styles.actions} ref="container">
        <div>
          {actions}
        </div>
      </div>
    );
  }
};

WidgetActions.propTypes = {
  widgetType: React.PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/widgetActions.jsx